import React from 'react'

export interface Props {
  width: number
  height: number
  color: React.CSSProperties['color']
  className?: React.HTMLAttributes<HTMLElement>['className']
}

const Logo: React.FC<Props> = ({ width, height, color, className }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 512 512"
  >
    <path
      style={{ fill: color }}
      d="M512,256c0,141.384-114.611,256-256.003,256C114.614,512,0,397.384,0,256
	C0,114.611,114.614,0,255.997,0C397.389,0,512,114.611,512,256z"
    />
    <path
      style={{ fill: color, filter: 'brightness(75%)' }}
      d="M363.587,188.997l-7.754-7.754c-17.254-15.322-38.986-23.004-60.664-23.004h-78.339
	c-3.246,0-6.482,0.189-9.713,0.532l-0.018-0.02c-0.233,0.028-0.461,0.077-0.694,0.105c-2.107,0.238-4.214,0.54-6.3,0.927
	c-0.223,0.041-0.443,0.069-0.666,0.115c-2.135,0.412-4.257,0.924-6.367,1.49c-0.481,0.131-0.965,0.251-1.441,0.387
	c-2.03,0.581-4.045,1.236-6.039,1.964c-0.484,0.172-0.965,0.358-1.446,0.543c-2.033,0.776-4.045,1.605-6.031,2.532
	c-0.287,0.133-0.568,0.287-0.855,0.422c-1.889,0.906-3.75,1.884-5.588,2.929c-0.312,0.179-0.625,0.335-0.937,0.52
	c-1.923,1.132-3.814,2.353-5.676,3.63c-0.392,0.266-0.778,0.54-1.17,0.814c-1.841,1.311-3.648,2.691-5.407,4.15
	c-0.312,0.261-0.614,0.532-0.916,0.794c-1.843,1.567-3.651,3.197-5.389,4.938c-8.922,8.927-15.616,19.236-20.078,30.244
	c-4.352,10.714-6.582,22.09-6.656,33.498c-1.503,0.438-2.854,1.247-3.912,2.342c-1.649,1.649-2.673,3.95-2.673,6.438
	c0,2.998,1.426,5.632,3.656,7.314c-1.17,1.536-1.897,3.364-1.897,5.343c0,1.203,0.069,2.337,0.218,3.433
	c-1.244,1.541-1.976,3.548-1.976,5.706c0,0.573,0.067,1.134,0.172,1.674c0.031,0.182,0.084,0.351,0.125,0.527
	c0.092,0.351,0.197,0.694,0.323,1.032c0.084,0.218,0.179,0.428,0.282,0.637c0.108,0.233,0.23,0.458,0.366,0.684
	c0.164,0.279,0.33,0.556,0.527,0.819c0.55,0.753,1.216,1.421,1.966,1.971l0.077,0.082l4.536,4.534
	c-1.185,1.454-1.825,3.22-1.825,5.007c0,12.321,3.912,24.612,11.807,34.888l174.63,174.63
	c91.323-20.324,164.221-89.398,190.026-178.527L363.587,188.997z"
    />
    <path
      style={{ fill: '#FF9D4D' }}
      d="M384.312,290.757c-1.526-1.531-3.533-2.296-5.535-2.296h-245.55c-2.01,0-4.017,0.768-5.545,2.296
	s-2.296,3.533-2.296,5.54c0,14.707,5.612,29.42,16.832,40.637c11.223,11.223,25.93,16.829,40.643,16.829h146.286
	c14.7,0,29.412-5.606,40.637-16.829c11.215-11.218,16.827-25.93,16.827-40.637C386.611,294.29,385.843,292.288,384.312,290.757z"
    />
    <path
      style={{ fill: '#F28124' }}
      d="M393.139,279.316c0,5.033-4.114,9.142-9.137,9.142H128c-5.036,0-9.144-4.109-9.144-9.142l0,0
	c0-5.025,4.109-9.144,9.144-9.144h256C389.025,270.172,393.139,274.294,393.139,279.316L393.139,279.316z"
    />
    <path
      style={{ fill: '#F2F9FF' }}
      d="M320.865,316.321c-24.637-20.447-102.075-38.06-102.075-38.06s125.878-6.781,159.987-12.767
	C362.668,271.48,331.098,324.813,320.865,316.321z"
    />
    <path
      style={{ fill: '#FF9D4D' }}
      d="M386.611,249.656H125.386l0,0c0-23.393,8.927-46.797,26.78-64.648
	c17.853-17.853,41.254-26.778,64.65-26.778h78.367c23.401,0,46.794,8.927,64.648,26.778
	C377.682,202.86,386.611,226.263,386.611,249.656L386.611,249.656z"
    />
    <path
      style={{ fill: '#F28124' }}
      d="M393.139,257.549c0,5.028-4.114,9.142-9.137,9.142H128c-5.036,0-9.144-4.111-9.144-9.142l0,0
	c0-5.028,4.109-9.142,9.144-9.142h256C389.025,248.407,393.139,252.521,393.139,257.549L393.139,257.549z"
    />
    <path
      style={{ fill: '#C1D354' }}
      d="M378.294,260.214c-146.02,16.707-199.578-7.24-245.944-0.998
	c-4.972,0.668-11.735,4.895-11.735,10.977c0,13.105,8.059,18.716,15.875,20.155c23.35,4.311,29.949-15.276,48.484-16.438
	c28.086-1.761,30.41,18.25,54.049,18.25c26.55,0,45.064-19.768,90.552-16.73c37.734,2.514,46.267,5.622,55.734,2.248
	c4.677-1.667,7.831-4.726,7.831-9.244C393.139,260.262,383.288,259.645,378.294,260.214z"
    />
    <g>
      <path
        style={{ fill: '#F28124' }}
        d="M194.957,196.485c0,4.114-3.625,7.447-8.095,7.447c-4.48,0-8.102-3.333-8.102-7.447
		c0-4.106,3.62-7.444,8.102-7.444C191.332,189.041,194.957,192.381,194.957,196.485z"
      />
      <path
        style={{ fill: '#F28124' }}
        d="M233.672,182.131c0,3.771-3.325,6.84-7.437,6.84c-4.111,0-7.444-3.069-7.444-6.84
		c0-3.786,3.333-6.84,7.444-6.84S233.672,178.345,233.672,182.131z"
      />
      <path
        style={{ fill: '#F28124' }}
        d="M313.779,206.141c0,2.675-2.355,4.833-5.256,4.833c-2.9,0-5.253-2.156-5.253-4.833
		c0-2.668,2.353-4.826,5.253-4.826C311.424,201.316,313.779,203.474,313.779,206.141z"
      />
      <path
        style={{ fill: '#F28124' }}
        d="M347.932,201.318c0,3.771-3.331,6.84-7.437,6.84c-4.106,0-7.452-3.069-7.452-6.84
		c0-3.786,3.346-6.84,7.452-6.84C344.602,194.478,347.932,197.532,347.932,201.318z"
      />
      <ellipse
        style={{ fill: '#F28124' }}
        cx="335.027"
        cy="232.013"
        rx="5.473"
        ry="5.03"
      />
      <path
        style={{ fill: '#F28124' }}
        d="M298.785,178.34c0,3.771-3.338,6.84-7.444,6.84s-7.437-3.069-7.437-6.84
		c0-3.768,3.331-6.833,7.437-6.833S298.785,174.569,298.785,178.34z"
      />
      <path
        style={{ fill: '#F28124' }}
        d="M238.331,225.948c0,6.139-5.404,11.103-12.099,11.103c-6.687,0-12.101-4.964-12.101-11.103
		c0-6.149,5.414-11.136,12.101-11.136C232.927,214.812,238.331,219.799,238.331,225.948z"
      />
      <path
        style={{ fill: '#F28124' }}
        d="M247.204,205.048c0,1.946-1.72,3.54-3.848,3.54c-2.117,0-3.837-1.595-3.837-3.54
		c0-1.948,1.72-3.533,3.837-3.533C245.484,201.516,247.204,203.098,247.204,205.048z"
      />
      <path
        style={{ fill: '#F28124' }}
        d="M165.891,235.592c0,2.557-2.255,4.636-5.043,4.636c-2.772,0-5.028-2.079-5.028-4.636
		c0-2.555,2.255-4.626,5.028-4.626C163.635,230.966,165.891,233.037,165.891,235.592z"
      />
      <path
        style={{ fill: '#F28124' }}
        d="M286.044,230.958c0,3.328-2.934,6.034-6.554,6.034c-3.633,0-6.561-2.706-6.561-6.034
		c0-3.333,2.929-6.016,6.561-6.016C283.11,224.945,286.044,227.628,286.044,230.958z"
      />
    </g>
  </svg>
)

export default Logo
